module.exports = __webpack_public_path__ + "img/powered-by-wifeed.86984a8d.png";